/**
 * Cart drawer: adding a product shows a confirmation instead of sliding the drawer open,
 * and the header height is published as a CSS variable so the panel can hang below it.
 */
(function () {
  var VISIBLE_FOR = 2600;
  var POLL_EVERY = 200;
  var GIVE_UP_AFTER = 10000;

  var hideTimer = null;
  var openedFromHeader = false;

  // getHeaderHeight() reports only one of the stacked header wrappers, so take the
  // lowest edge anything header-like actually occupies instead.
  var HEADER_PARTS = [
    '.header-sticky-wrapper',
    '.header-section',
    '#shopify-section-header',
    '.mobile-header',
  ];

  function publishHeaderHeight() {
    var bottom = 0;

    HEADER_PARTS.forEach(function (selector) {
      Array.prototype.forEach.call(document.querySelectorAll(selector), function (el) {
        var box = el.getBoundingClientRect();
        // near the top of the page and actually taking up room — the announcement
        // strip above the navigation is covered by the navigation's own bottom edge
        if (box.height > 0 && box.top < 200 && box.bottom > bottom) {
          bottom = box.bottom;
        }
      });
    });

    bottom = Math.max(0, Math.min(Math.round(bottom), 300));
    document.documentElement.style.setProperty('--cart-drawer-top', bottom + 'px');
  }

  publishHeaderHeight();
  window.addEventListener('resize', publishHeaderHeight);
  window.addEventListener('load', publishHeaderHeight);

  // Lock on the document element, not body: the header is sticky and `body { overflow:
  // hidden }` scrolls it away. Scrollbar width is paid back as padding to avoid a jump.
  var pageLocked = false;
  var savedPadding = '';

  function lockPage() {
    if (pageLocked) return;
    var root = document.documentElement;
    var gap = window.innerWidth - root.clientWidth;
    savedPadding = root.style.paddingRight;
    if (gap > 0) root.style.paddingRight = gap + 'px';
    root.style.overflow = 'hidden';
    pageLocked = true;
  }

  function unlockPage() {
    if (!pageLocked) return;
    var root = document.documentElement;
    root.style.overflow = '';
    root.style.paddingRight = savedPadding;
    pageLocked = false;
  }

  // Every route out of the panel drops the same class, so the lock follows the class
  // rather than any one handler. (Escape is bound to the search field, not the drawer.)
  var panelWatched = false;

  // `#theme-ajax-cart` is rendered three times (both headers + layout), so the id
  // is not unique: watch every copy, not just the first querySelector match.
  function watchPanel() {
    if (panelWatched) return;
    var panels = document.querySelectorAll('#theme-ajax-cart');
    if (!panels.length) return;
    panelWatched = true;

    var sync = function () {
      var anyVisible = Array.prototype.some.call(panels, function (panel) {
        return panel.classList.contains('is-visible');
      });
      if (anyVisible) lockPage();
      else unlockPage();
    };

    Array.prototype.forEach.call(panels, function (panel) {
      new MutationObserver(sync).observe(panel, { attributes: true, attributeFilter: ['class'] });
    });
    sync();
  }

  function swallow(event) {
    event.preventDefault();
  }

  var overlayGuarded = false;

  function guardOverlay() {
    if (overlayGuarded) return;
    var overlay = document.querySelector('.ajax-cart__overlay');
    if (!overlay) return;
    overlayGuarded = true;
    overlay.addEventListener('wheel', swallow, { passive: false });
    overlay.addEventListener('touchmove', swallow, { passive: false });
  }

  function confirm() {
    return document.querySelector('[data-cart-add-confirmation]');
  }

  function hide(el) {
    el.classList.remove('is-visible');
    // Emptied so the next add is announced again by assistive technology.
    var text = el.querySelector('[data-cart-add-confirmation-text]');
    if (text) text.textContent = '';
  }

  function announce() {
    var el = confirm();
    if (!el) return;

    if (hideTimer) {
      clearTimeout(hideTimer);
      hideTimer = null;
    }

    var text = el.querySelector('[data-cart-add-confirmation-text]');
    if (text) text.textContent = el.getAttribute('data-message') || '';

    el.classList.add('is-visible');

    hideTimer = setTimeout(function () {
      hideTimer = null;
      hide(el);
    }, VISIBLE_FOR);
  }

  function bind() {
    var cart = window.PXUTheme && window.PXUTheme.jsAjaxCart;

    if (!cart || cart.addConfirmationBound) return false;
    if (cart.cart_action !== 'drawer') return false;
    if (typeof cart.showDrawer !== 'function') return false;

    cart.addConfirmationBound = true;
    var openDrawer = cart.showDrawer;

    cart.showDrawer = function () {
      if (openedFromHeader) {
        openedFromHeader = false;
        publishHeaderHeight();
        watchPanel();
        guardOverlay();
        return openDrawer.apply(this, arguments);
      }

      announce();
      return false;
    };

    return true;
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (target && target.closest && target.closest('[data-ajax-cart-trigger]')) {
        openedFromHeader = true;
        // Released after the theme's own click handler has run, so a trigger click
        // that never opens the drawer cannot leak into a later add-to-cart.
        setTimeout(function () {
          openedFromHeader = false;
        }, 0);
      }
    },
    true
  );

  watchPanel();

  if (!bind()) {
    var waited = 0;
    var poll = setInterval(function () {
      waited += POLL_EVERY;
      watchPanel();
      if (bind() || waited >= GIVE_UP_AFTER) clearInterval(poll);
    }, POLL_EVERY);
  }
})();
